var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "branding-carousel" },
    [
      _c(
        "VueSlickCarousel",
        _vm._b(
          {
            scopedSlots: _vm._u([
              {
                key: "prevArrow",
                fn: function() {
                  return [
                    _c("button", { staticClass: "custom-arrow" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("chevron_left")
                      ])
                    ])
                  ]
                },
                proxy: true
              },
              {
                key: "nextArrow",
                fn: function() {
                  return [
                    _c("button", { staticClass: "custom-arrow" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("chevron_right")
                      ])
                    ])
                  ]
                },
                proxy: true
              }
            ])
          },
          "VueSlickCarousel",
          _vm.settings,
          false
        ),
        [
          _vm._v(" "),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              { attrs: { href: "http://www.sparda.de/", target: "_blank" } },
              [
                _c("img", {
                  attrs: {
                    alt: "Sparda-Banken",
                    src: "images/Brandings/Logo_Sparda-Banken_mit_Claim.png"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              { attrs: { href: "http://www.targobank.de", target: "_blank" } },
              [
                _c("img", {
                  attrs: {
                    alt: "TARGOBANK AG & Co. KGaA",
                    src: "images/Brandings/logo_targobank.gif"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              { attrs: { href: "http://www.santander.de", target: "_blank" } },
              [
                _c("img", {
                  attrs: {
                    alt: "Santander Consumer Bank AG",
                    src: "images/Brandings/santander_logo.jpg"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              {
                attrs: { href: "http://www.degussa-bank.de", target: "_blank" }
              },
              [
                _c("img", {
                  attrs: {
                    alt: "Degussa Bank GmbH",
                    src: "images/Brandings/logo_degussa.jpg"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              { attrs: { href: "http://www.bbbank.de", target: "_blank" } },
              [
                _c("img", {
                  attrs: {
                    alt: "BBBank eG",
                    src: "images/Brandings/bbbank_logo.gif"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              {
                attrs: { href: "http://www.suedwestbank.de", target: "_blank" }
              },
              [
                _c("img", {
                  attrs: {
                    alt: "SÜDWESTBANK AG",
                    src: "images/Brandings/suedwestbank.gif"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              {
                attrs: { href: "http://www.national-bank.de", target: "_blank" }
              },
              [
                _c("img", {
                  attrs: {
                    alt: "National-Bank",
                    src: "images/Brandings/logo_n_bank.png"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              { attrs: { href: "http://www.flessabank.de", target: "_blank" } },
              [
                _c("img", {
                  attrs: {
                    alt: "BANKHAUS MAX FLESSA KG",
                    src: "images/Brandings/flessabank.jpg"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              { attrs: { href: "http://www.pax-bank.de", target: "_blank" } },
              [
                _c("img", {
                  attrs: {
                    alt: "Pax-Bank eG",
                    src: "images/Brandings/pax-logo.png"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              {
                attrs: { href: "http://www.merkur-bank.de", target: "_blank" }
              },
              [
                _c("img", {
                  attrs: {
                    alt: "MERKUR BANK KGaA",
                    src: "images/Brandings/merkur.png"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              { attrs: { href: "http://www.sperrer.de", target: "_blank" } },
              [
                _c("img", {
                  attrs: {
                    alt: "Bankhaus Ludwig Sperrer KG",
                    src: "images/Brandings/sperrer.jpg"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "http://www.donner-reuschel.de",
                  target: "_blank"
                }
              },
              [
                _c("img", {
                  attrs: {
                    alt: "Donner & Reuschel Aktiengesellschaft",
                    src: "images/Brandings/donner.gif"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              { attrs: { href: "http://www.hafnerbank.de", target: "_blank" } },
              [
                _c("img", {
                  attrs: {
                    alt: "ANTON HAFNER KG",
                    src: "images/Brandings/hafner.gif"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "http://www.bankhaus-faisst.de",
                  target: "_blank"
                }
              },
              [
                _c("img", {
                  attrs: {
                    alt: "Bankhaus J. Faisst OHG",
                    src: "images/Brandings/faisst_bank_logo.jpg"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              { attrs: { href: "http://www.martinbank.de", target: "_blank" } },
              [
                _c("img", {
                  attrs: {
                    alt: "Bankhaus Gebr. Martin AG",
                    src: "images/Brandings/Logo_Bankhaus_Gebr_Martin_farbig.jpg"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "http://www.gabler-saliter-bank.de",
                  target: "_blank"
                }
              },
              [
                _c("img", {
                  attrs: {
                    alt: "Gabler-Saliter Bankgeschäft KG",
                    src: "images/Brandings/gabler_saliter.gif"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              { attrs: { href: "https://www.olb.de", target: "_blank" } },
              [
                _c("img", {
                  attrs: {
                    alt: "Oldenburgische Landesbank AG",
                    src: "images/Brandings/logo_olb.png"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.neelmeyer.de/home/#OpenExternal",
                  target: "_blank"
                }
              },
              [
                _c("img", {
                  attrs: {
                    alt: "Bankhaus Neelmeyer",
                    src: "images/Brandings/Logo_Bankhaus_Neelmeyer.gif"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              {
                attrs: { href: "http://www.steyler-bank.de", target: "_blank" }
              },
              [
                _c("img", {
                  attrs: {
                    alt: "Steyler Bank GmbH",
                    src: "images/Brandings/steyler_bank.gif"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "http://www.bankhaus-mayer.de",
                  target: "_blank"
                }
              },
              [
                _c("img", {
                  attrs: {
                    alt: "Bankhaus E. Mayer AG",
                    src: "images/Brandings/logo_bhm.gif"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "carousel-item" }, [
            _c(
              "a",
              {
                attrs: { href: "http://www.seeligerbank.de", target: "_blank" }
              },
              [
                _c("img", {
                  attrs: {
                    alt: "Bankhaus C.L. Seeliger",
                    src: "images/Brandings/logo_cls_g.gif"
                  }
                })
              ]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }